module.exports = __webpack_public_path__ + "img/identity.daa46b6e.png";